import '../../../scss/critical.scss';
import '../../../scss/blog.scss';

const $ = require('jquery');
global.$ = global.jQuery = $;
import 'bootstrap/js/dist/scrollspy';

$(document).ready(function () {
    import(
        /* webpackMode: "eager" */
        '../qg-main'
    ).then(function () {       
        const fileFormatsSearch = document.getElementById("file-format-search");
        const dictionarySearch = document.getElementById("dictionary-search");
        const fileFormatItems = document.querySelectorAll("#file-formats-items-row .col-4");
        const dictionaryItems = document.querySelectorAll("#dictionary-items-row .col-4");
        const fileFormatsNothingFound = document.getElementById("file-formats-empty");
        const dictionaryNothingFound = document.getElementById("dictionary-empty");

        fileFormatsSearch?.addEventListener("input", () => filterItems(fileFormatItems, fileFormatsSearch.value, fileFormatsNothingFound));
        dictionarySearch?.addEventListener("input", () => filterItems(dictionaryItems, dictionarySearch.value, dictionaryNothingFound));

        function filterItems(items, searchText, nothingFoundElement) {
            searchText = searchText.toLowerCase();
            let found = false;

            items.forEach(item => {
                const itemText = item.textContent.toLowerCase();
                const display = itemText.includes(searchText) ? "block" : "none";
                
                item.style.setProperty("display", display, "important");

                const fileFormatCategory = document.querySelectorAll("#file-formats-category");
                if (fileFormatCategory) {
                    fileFormatCategory.forEach(category => category.style.setProperty("display", display, "important"));
                }

                if (display === "block") {
                    found = true;
                }
            });

            if (!found) {
                nothingFoundElement.removeAttribute("hidden");
            } else {
                nothingFoundElement.setAttribute("hidden", "true");
            }
        }
    });
});
